<template>
    <div>
        <v-btn
            rounded
            small
            class="error white--text"
            :disabled="disabled || loading || !diaryId"
            @click="open"
        >
            <v-icon left small>mdi-close-circle-outline</v-icon>
            Rejeitar
        </v-btn>

        <v-dialog
            v-model="dialog"
            max-width="620"
            persistent
        >
            <v-card class="rounded-xl">
                <v-card-title class="error white--text d-flex align-center">
                    <v-icon left color="white">mdi-alert-circle-outline</v-icon>
                    Rejeitar diária
                </v-card-title>

                <v-card-text class="pt-5">
                    <v-alert
                        dense
                        outlined
                        type="warning"
                        class="mb-4"
                    >
                        Esta rejeição é apenas simbólica. A diária poderá ser editada e, ao ser gravada novamente, deixa de aparecer como rejeitada.
                    </v-alert>

                    <div class="text-subtitle-2 mb-2">
                        Comentário da rejeição
                    </div>

                    <v-textarea
                        v-model="comment"
                        outlined
                        auto-grow
                        rows="4"
                        counter="1000"
                        maxlength="1000"
                        label="Escreva o motivo da rejeição"
                        placeholder="Ex.: Existem horas incorretas na mão de obra externa..."
                        :disabled="loading"
                        :error-messages="commentError"
                        @input="commentError = null"
                    />
                </v-card-text>

                <v-card-actions class="px-6 pb-5">
                    <v-spacer />

                    <v-btn
                        text
                        :disabled="loading"
                        @click="close"
                    >
                        Cancelar
                    </v-btn>

                    <v-btn
                        class="error white--text"
                        rounded
                        :loading="loading"
                        @click="submit"
                    >
                        <v-icon left small>mdi-content-save-outline</v-icon>
                        Gravar rejeição
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <SuccessSnackbar
            v-model="success"
            message="Diária rejeitada com sucesso."
        />

        <ErrorSnackbar
            v-model="error.show"
            :message="error.message"
        />
    </div>
</template>

<script>
import DiaryRejections from "@/api/DiaryRejections.js";
import SuccessSnackbar from "@/components/UI/Snackbars/SuccessSnackbar";
import ErrorSnackbar from "@/components/UI/Snackbars/ErrorSnackbar";

export default {
    name: "RejectDiary",

    components: {
        SuccessSnackbar,
        ErrorSnackbar,
    },

    props: {
        diaryId: {
            type: String,
            default: null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            dialog: false,
            loading: false,
            comment: "",
            commentError: null,
            success: false,
            error: {
                show: false,
                message: null,
            },
        };
    },

    methods: {
        open() {
            this.comment = "";
            this.commentError = null;
            this.dialog = true;
        },

        close() {
            if (this.loading) {
                return;
            }

            this.dialog = false;
            this.comment = "";
            this.commentError = null;
        },

        async submit() {
            const comment = String(this.comment || "").trim();

            if (!comment) {
                this.commentError = "O comentário é obrigatório.";
                return;
            }

            if (!this.diaryId) {
                this.error.message = "Não foi possível identificar a diária.";
                this.error.show = true;
                return;
            }

            this.loading = true;

            try {
                const response = await DiaryRejections.create({
                    diary_id: this.diaryId,
                    comment,
                });

                this.success = true;
                this.dialog = false;

                this.$emit("rejected", response.data);
            } catch (error) {
                this.error.message =
                    error?.response?.data?.message ||
                    "Não foi possível rejeitar a diária.";
                this.error.show = true;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.rounded-xl {
    border-radius: 18px !important;
}
</style>